import httpClient from '@/api/http-client';

const endpoint = 'api/questionnaires';

const questionnaireService = {
  getPage: (params) => httpClient.get(endpoint, { params }),

  getById: (id) => httpClient.get(`${endpoint}/${id}`),

  create: (questionnaire) => httpClient.post(`${endpoint}`, questionnaire),

  update: (questionnaire) => httpClient.put(`${endpoint}/${questionnaire.id}`, questionnaire),

  search: (search) => httpClient.post(`${endpoint}/find`, { search }),

  delete: (questionnaire) => httpClient.delete(`${endpoint}/${questionnaire.id}`),

  reorder: (questionnaireIds) =>
    httpClient.post(`${endpoint}/sort`, { questionnaire_ids: questionnaireIds }),
};

export default questionnaireService;
